































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { User } from '@/models/user';
import type { Company } from '@/models/company';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'Overview',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
})
export default class Overview extends Vue {
    @Getter('account/userInfo') private userInfo: User;
    @Getter('account/company') private company: Company;
}
